import {gql} from '@apollo/client';

export const PRODUCT_FIELDS_V2 = ({
  enableRmsStatus,
  enableUltraFresh = false,
  enableSellInPiece = false,
  enable1PX = false,
  shouldFetchDeliveryDescription,
  enableBrandDetails = false,
  isProPointsEnabled = false,
  isUnavailableReasonEnabled = false,
  is3PComplexPromotionEnabled = false
}: {
  enableSellInPiece: boolean;
  enable1PX: boolean;
  enableRmsStatus?: boolean;
  enableUltraFresh?: boolean;
  shouldFetchDeliveryDescription?: boolean;
  enableBrandDetails: boolean;
  isProPointsEnabled?: boolean;
  isUnavailableReasonEnabled?: boolean;
  is3PComplexPromotionEnabled?: boolean;
}) => `
      id
      title
      brand
      ${
        enableBrandDetails
          ? `
          brandDetails {
            displayName
            flexiPageHandle
            logoUrl
          }
            `
          : ''
      }
      description
      size
      size
      displayPrice
      originPrice
      priceUnit
      discountEndDate
      discountStartDate
      imageUrls
      seller
      sku
      skuCode
      status
      isBulky 
      ${enable1PX ? 'is1PX' : ''}
      isAlcohol
      deliveryIn24Hrs
      moq
      isWeightedFresh
      ${enableSellInPiece ? 'sellInPiece' : ''}
      installmentType
      isPreOrder
      ${
        isUnavailableReasonEnabled
          ? `unavailableReason {
        code
        message
      }`
          : ''
      }
      ${enableUltraFresh ? 'isUltraFresh' : ''}
      variants {
          id
          sku
          price
          storeCode
          outsideOfDeliveryZone
          metafields {
            value
            key
          }
          compareAtPrice
          discountEndDate
          discountStartDate
          inventoryQuantity
          isExpressDelivery
          ${
            is3PComplexPromotionEnabled
              ? `
            complexPromotion3P {
              title
              startDate
              endDate
              maxQuantityToDiscount
              rewardType
              rewardValue
              targetType
              targetValue
              miraklPromotionId
            }`
              : ''
          }

         ${enableRmsStatus ? 'rmsStatus' : ''}
        }
      totalInventory
      measurements {
        height
        length
        width
        dimensionUnit
        weight
        weightUnit
      }
      sellerDetails {
        marketplaceType
        fulfilledByPlatform
        shopId
        shopName
      }
      shippingInfo {
        deliveryTimeEarliestDate
        deliveryTimeLatestDate
        deliveryTimeEarliestDays
        deliveryTimeLatestDays
        shippingPrice
        zone
      }
      collections {
      id
      handle
      title
      startDate
      endDate
      imageUrl
      type
      description
      titleAlt
      displayOrder
      promotion {
        conditionType
        maxCap
        conditionDetail {
          rewardType
          rewardValue
          targetValue
          targetType
        }
        title
        titleTh
          ${
            isProPointsEnabled
              ? `ruleId
              terms
              skuCount
              maxCap`
              : ''
          }
        }
        countdownTimer {
          title
          startDateTime
          endDateTime
          timerId
        }
        frameEn
        frameTh
        frame {
          title
          top
          bottom
          left
          right
          scale
          frameImage
          frameImageEn
          platform
        }
      }
      slabPrices {
        slabPriceDescription
        slabPriceTiers {
          discount
          priceInVat
          quantity
          tier
        }
      }
      storageInformation
      expiryDays
      upcharge {
        percentage
        minimumThreshold
      }
      ${
        shouldFetchDeliveryDescription
          ? `deliveryDescription {
        singleLine
        summary
        popup
      }`
          : ''
      }
  `;

export const GET_PRODUCT_LIST_RAW_QUERY_V2 = ({
  shouldFetchDeliveryDescription,
  enableRmsStatus,
  enableUltraFresh,
  enableSellInPiece,
  enable1PX,
  enableBrandDetails,
  isProPointsEnabled,
  isUnavailableReasonEnabled,
  is3PComplexPromotionEnabled
}: any) => `
    query products(
      $ids: [String!]!
      $storeCodes: [String!]
      $lang: String
      $allowAlcohol: Boolean
      $isSalesCustomer: Boolean
      $is3P: Boolean
      $membershipId: String
      $date: String
      ${shouldFetchDeliveryDescription ? `$isSameDayAllowedForStore: Boolean` : ''}
      $isExpressDeliveryStore: Boolean
    ) {
      products(ids: $ids, storeCodes: $storeCodes, lang: $lang, isSalesCustomer: $isSalesCustomer, allowAlcohol: $allowAlcohol, is3P: $is3P, membershipId: $membershipId, ${
        shouldFetchDeliveryDescription ? `isSameDayAllowedForStore: $isSameDayAllowedForStore` : ''
      }, date: $date, isExpressDeliveryStore: $isExpressDeliveryStore) {
        ${PRODUCT_FIELDS_V2({
          enableRmsStatus,
          enableUltraFresh,
          enableSellInPiece,
          shouldFetchDeliveryDescription,
          enable1PX,
          enableBrandDetails,
          isProPointsEnabled,
          isUnavailableReasonEnabled,
          is3PComplexPromotionEnabled
        })}
      }
    }
  `;

export const PRODUCT_DETAIL_BY_IDS_QUERY_V2 = ({
  enableSellInPiece,
  enableRmsStatus,
  enableUltraFresh,
  shouldFetchDeliveryDescription,
  enable1PX,
  enableBrandDetails,
  isProPointsEnabled,
  isUnavailableReasonEnabled,
  is3PComplexPromotionEnabled
}: {
  enableSellInPiece: boolean;
  enableRmsStatus?: boolean;
  enableUltraFresh?: boolean;
  shouldFetchDeliveryDescription?: boolean;
  enable1PX?: boolean;
  enableBrandDetails: boolean;
  isProPointsEnabled?: boolean;
  isUnavailableReasonEnabled?: boolean;
  is3PComplexPromotionEnabled?: boolean;
}) => {
  const gqlQueryString = GET_PRODUCT_LIST_RAW_QUERY_V2({
    enableSellInPiece,
    enableRmsStatus,
    enableUltraFresh,
    shouldFetchDeliveryDescription,
    enable1PX,
    enableBrandDetails,
    isProPointsEnabled,
    isUnavailableReasonEnabled,
    is3PComplexPromotionEnabled
  });
  return gql`
    ${gqlQueryString}
  `;
};
